/*
* @ngdoc Config
* @name app.configs.AppHeadings
* @description
* The class is used to holding the static text, we are going to use in the application
* */

export class AppHeadings {

}